import React, { useCallback, useState, Component } from 'react';
import {mouseDown} from 'actions/index.js';
import { connect } from "react-redux";
import {setMasterStepToggles} from 'actions/index.js';
import RollVisualizer from './RollVisualizer.js';
import Step from './Step.js';

export const StepsVisualizer = (props) => {
    const onClickStep = useCallback((i)=> {
        let toggles = props.masterStepToggles;
        toggles[i] = !toggles[i];
        props.setMasterStepToggles(toggles);
    }, []);

    const onMouseOver = useCallback((i) => {
        let isMouseDown = props.sequencerEngine.state.keyboard.isMouseDown;
        if (isMouseDown) {
            onClickStep(i);
        }
    }, []);

    let steps = Array(16).fill(0);
    let stepNumber = props.stepNumber;
    let rollingStepNumber = undefined;
    let rollSteps = undefined;
    let rollStart = undefined;
    if (props.isSequenceRolling) {
        let track = props.sequencerEngine.tracks[0];
        if (track) {
            let resolution = track.getFactoredResolution();
            let steps = resolution.getNumberOfStepsAtBaseResolution();
            let _stepNumber = track.patternRollStepNumber + props.stepNumber % steps;
            rollingStepNumber = _stepNumber % track.pattern.stepBuckets.length;
            rollSteps = steps;
            rollStart = track.patternRollStepNumber;
        }
    }
    return (
        <div
          onMouseUp={() => props.mouseDown(false)}
          onMouseDown={() => props.mouseDown(true)}
          className="steps-visualizer">
          {props.isSequenceRolling ? <RollVisualizer rollSteps={rollSteps} stepNumber={rollStart}/> : ''}
          {steps.map((step, i) =>
                     <Step
                       key={i}
                       sequencerEngine={props.sequencerEngine}
                       onMouseOver={() => onMouseOver(i)}
                       onMouseDown={() => onClickStep(i)}
                       stepNumber={i}
                       rollingStepNumber={rollingStepNumber !== undefined ? stepNumber : rollingStepNumber}
                       currentStep={rollingStepNumber !== undefined ? rollingStepNumber : stepNumber}
                     />)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let id = props.sequencerEngine.getSequenceId();
    return {
        stepNumber: state.sequencer.currentGlobalStep[id] || 0,
        masterStepToggles: state.steps.masterStepToggles,
        isSequenceRolling: props.sequencerEngine.isSequenceRolling
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setMasterStepToggles: toggles => dispatch(setMasterStepToggles(toggles)),
        mouseDown: x => dispatch(mouseDown(x))
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(StepsVisualizer);

